import React from 'react';

type Props = {
  imageUrl?: string;
  title?: string;
  subtitle?: string;
  copy?: string;
  ctaText?: string;
};

export const CareerHero = ({ title, subtitle, imageUrl, copy, ctaText }: Props) => {
  return (
    <section className="career-hero">
      <div className="career-hero__media media-cover">
        {imageUrl && <img src={imageUrl} alt="Careers at Alo" loading="lazy" />}
        <div className="career-hero__title">{title && <h1 className="career-hero__title">{title}</h1>}</div>
      </div>
      <div className="career-hero__content">
        <div className="career-hero__info">
          {subtitle && <h5 className="h5 uppercase">{subtitle}</h5>}
          {copy && <div className="body" dangerouslySetInnerHTML={{ __html: copy }}></div>}
          {ctaText && (
            <a className="hero-button" href="#job-listings">
              {ctaText}
            </a>
          )}
        </div>
      </div>
    </section>
  );
};
